$(document).ready(function() {
  $("#zipCode").on('keydown',function(e) {
    if(e.which == 13) {
        if ($(this).val()) {
          $("#applyButton").click();
        }
        event.preventDefault();
        return false;
    }
  });
})
